import { NgModule } from "@angular/core";
import { AuthenticationGuard } from "./authentication.guard";
import { PendingChangesGuard } from "./pending-changes.guard";

@NgModule({
    providers: [AuthenticationGuard, PendingChangesGuard]
})
export class GuardsModule {
}
